import React from 'react';
import Styled from './Rewards.style';
import { Button, Icon, Input } from '../../components/index';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Col, Row } from 'react-styled-flexboxgrid';
import { useTranslation } from 'react-i18next';
import store from 'store2';
interface TaskFormProps {
  isDesktop: boolean;
  postLeakRepairSignup: Function;
  challengeTag?: any;
  icon?: any;
  title?: any;
  description?: any;
  closeDescription?: any;
  closeTitle?: any;
  leakFixSignup?: any;
  formElements?: any;
  id?: any;
  tag?: string;
  buttonText: string;
}

const TaskForm: React.FC<TaskFormProps> = (props) => {
  const { postLeakRepairSignup, leakFixSignup, isDesktop } = props;
  const [t] = useTranslation('common');
  const propertyId = store('property');
  const bonusTaskSignup = leakFixSignup;

  const renderFormElements = () => {
    const SignUpSchema = Yup.object().shape({
      name: Yup.string().when([], {
        is: () =>
          props.formElements['form-elements'] &&
          props.formElements['form-elements'].name,
        then: Yup.string()
          .required(`${t('portal.general_form_errors.required')}`)
          .min(1, 'Name is too few characters'),
        otherwise: Yup.string(),
      }),
      contactNumber: Yup.string().when([], {
        is: () =>
          props.formElements['form-elements'] &&
          props.formElements['form-elements'].telephone,
        then: Yup.string()
          .matches(
            /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$/,
            `${t('portal.general_form_errors.contact_not_valid')}`
          )
          .required(`${t('portal.general_form_errors.required')}`),
        otherwise: Yup.string().matches(
          /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$/,
          `${t('portal.general_form_errors.contact_not_valid')}`
        ),
      }),
      houseNumber: Yup.string().when([], {
        is: () =>
          props.formElements['form-elements'] &&
          props.formElements['form-elements'].houseNumber,
        then: Yup.string()
          .min(1, `${t('portal.general_form_errors.house_number_not_valid')}`)
          .required(`${t('portal.general_form_errors.required')}`),
        otherwise: Yup.string(),
      }),
      street: Yup.string().when([], {
        is: () =>
          props.formElements['form-elements'] &&
          props.formElements['form-elements'].street,
        then: Yup.string()
          .min(1, `${t('portal.general_form_errors.street_not_valid')}`)
          .required(`${t('portal.general_form_errors.required')}`),
        otherwise: Yup.string(),
      }),
    });
    return (
      <>
        <Icon size={isDesktop ? 100 : 75} icon={props.icon} />
        {bonusTaskSignup !== undefined ? (
          <>
            <Styled.Wrap style={{ width: isDesktop ? 500 : '100%' }}>
              <Styled.SlideTitle>
                {t(props.formElements.closeTitle)}
              </Styled.SlideTitle>
              <Styled.SlideDescription
                style={{ fontSize: isDesktop ? '16px' : '14px' }}
              >
                {t(props.formElements.closeDescription)}
              </Styled.SlideDescription>
            </Styled.Wrap>
            <Button
              onClick={() => {
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              }}
            >
              CLOSE
            </Button>
          </>
        ) : (
          <>
            <Styled.Wrap style={{ width: isDesktop ? 500 : '100%' }}>
              {props.formElements.title && (
                <Styled.SlideTitle>
                  {t(props.formElements.title)}
                </Styled.SlideTitle>
              )}{' '}
              <Styled.SlideDescription
                style={{ fontSize: isDesktop ? '16px' : '14px' }}
              >
                {t(props.formElements.description)}{' '}
              </Styled.SlideDescription>
              <Formik
                initialValues={{
                  id: props.id,
                  property_id: propertyId,
                  tag: props.tag,
                  name: '',
                  contactNumber: '',
                  houseNumber: '',
                  street: '',
                }}
                validationSchema={SignUpSchema}
                onSubmit={(values, { setSubmitting }) => {
                  postLeakRepairSignup(
                    values,
                    props.tag,
                    props.id,
                    parseInt(propertyId),
                    setSubmitting(false)
                  );
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  /* and other goodies */
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Row>
                      <Col xs={12} sm={12}>
                        <div>
                          {props.formElements['form-elements'] &&
                          props.formElements['form-elements'].name ? (
                            <div>
                              <Input
                                type="text"
                                id="name"
                                label={`${t(
                                  props.formElements['form-elements'].name.text
                                )}`}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.name}
                              />
                              <Styled.Error>
                                {errors.name && touched.name && errors.name}
                              </Styled.Error>
                            </div>
                          ) : null}
                          {props.formElements['form-elements'] &&
                          props.formElements['form-elements'].telephone ? (
                            <div>
                              <Input
                                type="text"
                                id="contactNumber"
                                label={`${t(
                                  props.formElements['form-elements'].telephone
                                    .text
                                )}`}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.contactNumber}
                              />
                              <Styled.Error>
                                {errors.contactNumber &&
                                  touched.contactNumber &&
                                  errors.contactNumber}
                              </Styled.Error>
                            </div>
                          ) : null}
                          {props.formElements['form-elements'] &&
                          props.formElements['form-elements'].houseNumber ? (
                            <div>
                              <Input
                                type="text"
                                id="houseNumber"
                                label={`${t(
                                  props.formElements['form-elements']
                                    .houseNumber.text
                                )}`}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.houseNumber}
                              />
                              <Styled.Error>
                                {errors.houseNumber &&
                                  touched.houseNumber &&
                                  errors.houseNumber}
                              </Styled.Error>
                            </div>
                          ) : null}
                          {props.formElements['form-elements'] &&
                          props.formElements['form-elements'].street ? (
                            <div>
                              <Input
                                type="text"
                                id="street"
                                label={`${t(
                                  props.formElements['form-elements'].street
                                    .text
                                )}`}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.street}
                              />
                              <div>
                                {errors.street &&
                                  touched.street &&
                                  errors.street}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    {props.formElements['form-elements'] &&
                    props.formElements['form-elements'].disclaimer ? (
                      <Row>
                        <Col xs>
                          <p style={{ fontSize: '13px', margin: '0px' }}>
                            <i>
                              {t(
                                props.formElements['form-elements'].disclaimer
                              )}
                            </i>
                          </p>
                        </Col>
                      </Row>
                    ) : null}
                    <Row style={{ marginTop: '40px' }}>
                      <Col
                        xs
                        style={{
                          alignItems: 'center',
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <Button disabled={isSubmitting} type="submit">
                          {props.formElements.button
                            ? t(`${props.formElements.button.text}`)
                            : t('portal.forgot_password.submit_button')}
                        </Button>
                      </Col>
                    </Row>
                  </form>
                )}
              </Formik>
            </Styled.Wrap>
          </>
        )}
      </>
    );
  };

  return renderFormElements();
};

export default TaskForm;
